import { render, staticRenderFns } from "./mortgageToolTip.vue?vue&type=template&id=1e4dec04"
import script from "./mortgageToolTip.vue?vue&type=script&lang=ts"
export * from "./mortgageToolTip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports